import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material'
import {
  useVesselContext,
  vesselDialogs,
} from '../../../Contexts/Modules/SampleModule/VesselModule'
import { useMessagePopupContext } from '../../../garvan-react/Components/ModalFeedback/MessagePopup'
import { useStuartMutate } from '../../../APIs/Hooks/PhpAPIHooks'

function DestroyDialog() {
  const { openDialog, setOpenDialog, vesselQuery, setFields } =
    useVesselContext()
  const { setMessage } = useMessagePopupContext()
  const { mutate: destroy } = useStuartMutate(
    `/vessel/destroyVessel.php?&VesselID=${vesselQuery.data?.VesselID}`,
    (data) => {
      if (data?.Success) {
        setFields((f: any) => {
          return {
            ...f,
            destroy: data,
          }
        })
        setOpenDialog(vesselDialogs.DESTROY_CONFIRM)
      } else {
        setMessage({
          subject: 'Error',
          severity: 'warning',
          message: data?.message,
        })
      }
    },
  )
  return (
    <Dialog
      open={openDialog === vesselDialogs.DESTROY}
      onClose={() => setOpenDialog(undefined)}
    >
      <DialogTitle>{'Destroy Vessel?'}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {`Destroy Vessel ${vesselQuery.data?.VesselID} and all children Vessels and
          Samples?`}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => setOpenDialog(undefined)}
          color="error"
        >
          Cancel
        </Button>
        <Button
          onClick={() => destroy()}
          color="warning"
        >
          Destroy Vessel
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DestroyDialog
